import createEvent from '../utils/domEvents/createEvent';


const Key = {
  RETURN: 13,
  SPACE: 32,
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
};


class RadioButtonList {
  /**
   * @param {HTMLFormElement} $form
   * @param {HTMLUListElement} $list
   */
  constructor($form, $list, onChange = () => {}, stateClass = { checked: 'btn-primary', unchecked: 'btn-default' }) {
    this.$form = $form;
    this.$list = $list;
    this.$list.setAttribute('role', 'radiogroup');

    this.onChange = onChange;
    this.stateClass = stateClass;

    this.$items = [...$list.querySelectorAll('li')];

    const $checked = this.$items.find($li => $li.getAttribute('aria-checked') === 'true');

    this.$items.forEach(($item) => {
      this.resetListItem($item);

      $item.addEventListener('keydown', this.onListItemKeyDown);
      $item.addEventListener('click', () => this.setChecked($item));
    });

    if ($checked) {
      this.setChecked($checked, false);
    } else {
      const $first = this.$items[0];

      $first.setAttribute('tabindex', 0);
      this.setActiveDescendant($first);
    }
  }

  getSelectedItem() {
    return this.$current;
  }

  getItems() {
    return this.$items;
  }

  /**
   * @param {KeyboardEvent} event
   */
  onListItemKeyDown = (event) => {
    const $li = event.target;

    switch (event.keyCode) {
      case Key.SPACE:
        this.setChecked($li);
        break;

      case Key.UP:
      case Key.LEFT:
        this.setChecked(this.getPreviousItem($li));
        break;

      case Key.DOWN:
      case Key.RIGHT:
        this.setChecked(this.getNextItem($li));
        break;

      case Key.RETURN:
        this.submitForm();
        break;

      default:
        return;
    }

    event.stopPropagation();
    event.preventDefault();
  }

  submitForm = () => {
    this.$form.dispatchEvent(createEvent('submit', { cancelable: true }));
  }

  /**
   * @param {HTMLLIElement} $el
   */
  getNextItem($el) {
    const { $items } = this;
    const length = $items.length;
    const index = $items.indexOf($el);

    if (index < length - 1) {
      return $items[index + 1];
    }

    return $items[0];
  }

  /**
   * @param {HTMLLIElement} $li
   */
  getPreviousItem($li) {
    const { $items } = this;
    const index = $items.indexOf($li);

    if (index > 0) {
      return $items[index - 1];
    }

    return $items[$items.length - 1];
  }

  /**
   * @param {HTMLLIElement} $li
   */
  setChecked($li, callChange = true) {
    if ($li === this.$current) {
      return;
    }

    this.$items.forEach(this.resetListItem);

    $li.setAttribute('tabindex', 0);
    $li.setAttribute('aria-checked', 'true');
    $li.focus();

    this.setActiveDescendant($li);

    const { stateClass } = this;

    $li.classList.remove(stateClass.unchecked);
    $li.classList.add(stateClass.checked);

    /** @type {HTMLLIElement} */
    this.$current = $li;

    if (callChange) {
      this.onChange();
    }
  }

  /**
   * @param {HTMLLIElement} $li
   */
  setActiveDescendant($li) {
    this.$list.setAttribute('aria-activedescendant', $li.id);
  }

  /**
   * @param {HTMLLIElement} $li
   */
  resetListItem = ($li) => {
    const { stateClass } = this;

    $li.classList.remove(stateClass.checked);
    $li.classList.add(stateClass.unchecked);

    $li.setAttribute('tabindex', -1);
    $li.setAttribute('aria-checked', 'false');
  }
}

export default RadioButtonList;



// WEBPACK FOOTER //
// ./src/onePageGiving/RadioButtonList.js